// extracted by mini-css-extract-plugin
export default {"loggedOut":"LoggedAsTherapistBuyTest_loggedOut__BORt6","textContainer":"LoggedAsTherapistBuyTest_textContainer__+7Vu4"};